<div class="resource-server-summary" role="status" aria-live="polite">
  <span class="resource-server-summary__icon" aria-hidden="true">
    @switch (display().icon) {
      @case ('network') {
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6" cy="12" r="2.5" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="18" cy="6" r="2.5" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="18" cy="18" r="2.5" stroke="currentColor" stroke-width="1.5"/>
          <path d="M8.2 11.2l7.1-3.4M8.2 12.8l7.1 3.4M15.5 8.5v7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      }
      @case ('globe') {
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
          <path d="M3 12h18M12 3c2.5 2.8 2.5 14.2 0 18M12 3c-2.5 2.8-2.5 14.2 0 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      }
      @case ('files') {
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="M14 2V8H20M12 18V12M9 15H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      }
      @case ('server') {
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="14" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="5" y="13" width="14" height="6" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="8" cy="8" r="0.75" fill="currentColor"/>
          <circle cx="8" cy="16" r="0.75" fill="currentColor"/>
        </svg>
      }
    }
  </span>
  <div class="resource-server-summary__text">
    <p class="resource-server-summary__label">
      Resource server:
      <strong>{{ display().title }}</strong>
    </p>
    @if (ogcModeLabel()) {
      <p class="resource-server-summary__sub">{{ ogcModeLabel() }}</p>
    }
  </div>
</div>
